// INVOICE_REPORT
export const GET_INVOICE_REPORT = "GET_INVOICE_REPORT";
export const GET_INVOICE_REPORT_SUCCESS = "GET_INVOICE_REPORT_SUCCESS";
export const GET_INVOICE_REPORT_FAIL = "GET_INVOICE_REPORT_FAIL";
export const INVOICE_REPORT_CLEAR_NOTIFY = "INVOICE_REPORT_CLEAR_NOTIFY";
